var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16.9167C16.5058 16.9167 18.125 15.2976 18.125 13.2917V6.04175C18.125 4.03591 16.5058 2.41675 14.5 2.41675C12.4942 2.41675 10.875 4.03591 10.875 6.04175V13.2917C10.875 15.2976 12.4942 16.9167 14.5 16.9167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5415 13.2917C20.5415 16.6267 17.8348 19.3334 14.4998 19.3334C11.1648 19.3334 8.45817 16.6267 8.45817 13.2917H6.0415C6.0415 17.5572 9.19525 21.0613 13.2915 21.6534V25.3751H15.7082V21.6534C19.8044 21.0613 22.9582 17.5572 22.9582 13.2917H20.5415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicicon);
export default __webpack_public_path__ + "static/media/mic icon.7a6b66211e82120fbb4186e1bc100188.svg";
export { ForwardRef as ReactComponent };